import React from "react"
import { useStateMachine } from "components/context/stateMachine/StateMachineV2"
import { Container, Stack, FlexContainer, Form, SlidingDotsLoader, H2, Text } from "@carrotfertility/carotene"
import useAboutYou, { formAboutYouAddressPayload } from "components/carrot-plans/hooks/useAboutYou"
import { AboutYou } from "types/carrotPlanTypes"
import { ReimbursementFormInternationalAddress } from "features/legacy-components/AboutYouFormInternationalAddress"
import { FormArrowSubmitButton } from "features/legacy-components/ArrowSubmitButton"

function canSkip(data: AboutYou): boolean {
  return (
    Boolean(data?.address?.internationalAddressLine) &&
    Boolean(data?.address?.internationalCountry) &&
    Boolean(data?.address?.city) &&
    Boolean(data?.address?.state)
  )
}

export const InternationalAddressUpdate = (): JSX.Element => {
  const { data, isLoading, updateAboutYou } = useAboutYou()
  const { send } = useStateMachine(canSkip(data) ? "" : null)

  async function onSubmit(data): Promise<void> {
    const aboutYouUpdate = formAboutYouAddressPayload(data)
    await updateAboutYou(aboutYouUpdate)
    send("")
  }
  return (
    <Container stack="48px">
      {isLoading ? (
        <FlexContainer direction="column" justifyContent="center">
          <SlidingDotsLoader />
        </FlexContainer>
      ) : (
        <>
          <Stack spacing="tiny" stack="48px">
            <H2>Confirm your address</H2>
            <Text>Please confirm or update your address so that we can reimburse you.</Text>
          </Stack>
          <Form onSubmit={onSubmit}>
            <Stack spacing="medium">
              <ReimbursementFormInternationalAddress
                defaultValues={{
                  city: data?.address?.city,
                  state: data?.address?.state,
                  zip: data?.address?.zip,
                  internationalCountry: data?.address?.internationalCountry,
                  internationalAddressLine: data?.address?.internationalAddressLine
                }}
              />
              <FlexContainer justifyContent="flex-end">
                <FormArrowSubmitButton>Continue</FormArrowSubmitButton>
              </FlexContainer>
            </Stack>
          </Form>
        </>
      )}
    </Container>
  )
}
